export const getColorForInitials = (initials: string) => {
  const colors = ["bg-primary", "bg-primary", "bg-primary"];
  const charCodeSum = initials
    .split("")
    .reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return colors[charCodeSum % colors.length];
};
